import { render, staticRenderFns } from "./navBtn.vue?vue&type=template&id=6a04df88&scoped=true&"
import script from "./navBtn.vue?vue&type=script&lang=js&"
export * from "./navBtn.vue?vue&type=script&lang=js&"
import style0 from "./navBtn.vue?vue&type=style&index=0&id=6a04df88&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a04df88",
  null
  
)

export default component.exports